import { action, observable } from 'mobx';
import { getExchangeUrl } from '@/utils/location';
import Axios from 'axios';
import SocketClient from '@/utils/socketClient';
import { API, WEBSOCKET_URL_MARKET, WEBSOCKET_URL_USER } from '../config/api';
import WebsocketInstance from '@/models/injection/websocketInstance';
import { StringNullableChain } from 'lodash';
interface ConfList {
  about_us: string;
  customer_service: string;
  help_center: string;
  notice_center: string;
  otc_url: string;
  qr_url: string;
  user_agreemen: string;
  fee_explain: string;
  vip_rule_explain: string;
  work_order: string;
  instructions: string;
  larding_page_url: string;
  verification_channel: string;
  privacy: string;
  cooperation: string;
  android_google_download: string;
  ios_google_download: string;
  disclaimer: string;
  risk_tips: string
}
export default class Home {
  @observable carouselList: any[];

  @observable confList: ConfList;

  @observable noticeList: any[];

  //marketSocket: SocketClient; // for 'sub_ticker', 'sub_mark_price', 'sub_kline'

  @observable appUrl: string;

  @observable iosUrl: string;
  @observable superSignUrl: string;
  @observable iphoneUrl: string;
  @observable androidUrl: string;
  @observable iosTestflightUrl: string;
  @observable iosAppstoreUrl: string;
  @observable googleUrl: string;

  constructor() {
    this.carouselList = [];
    this.iosUrl = '';
    this.iphoneUrl = '';
    this.superSignUrl = '';
    this.appUrl = '';
    this.androidUrl = '';
    this.iosTestflightUrl = '';
    this.iosAppstoreUrl = '';
    this.googleUrl = '';
    this.noticeList = [];
    this.confList = {
      about_us: '',
      customer_service: '',
      help_center: '',
      notice_center: '',
      otc_url: '',
      qr_url: '',
      user_agreemen: '',
      fee_explain: '',
      vip_rule_explain: '',
      work_order: '',
      instructions: '',
      larding_page_url: '',
      verification_channel: '',
      privacy: '',
      cooperation: '',
      android_google_download: '',
      ios_google_download: '',
    };
    // this.marketSocket = WebsocketInstance(WEBSOCKET_URL_MARKET, 'MARKET');
  }

  @action.bound
  setNotice(data: any) {
    this.noticeList = data;
  }
  @action.bound
  setConfList(data: ConfList) {
    this.confList = data;
  }
  @action.bound
  setCarouselList(data: any) {
    this.carouselList = data;
  }

  @action.bound
  setAppUrl(data: any) {
    this.appUrl = data;
    this.androidUrl = data;
  }

  @action.bound
  setIosUrl(data: any) {
    const { url, superSignUrl } = data;
    this.iosUrl = url;
    this.iosAppstoreUrl = url;
    this.superSignUrl = superSignUrl;
  }
  @action.bound
  setIphoneUrl(data: any) {
    this.iphoneUrl = data;
    this.iosTestflightUrl = data;
  }

  @action.bound
  setGoogleUrl(data: any) {
    this.googleUrl = data;
  }

  @action.bound
  async getCarouselList(type: number) {
    const result: any = await Axios.get(getExchangeUrl().carouselList, {
      params: {
        type,
      },
    });
    if (result) {
      this.setCarouselList(result);
    }
  }

  // 公告
  @action.bound
  async fetchNotice() {
    const result: any = await Axios.get(getExchangeUrl().notice);
    if (result) {
      const { articles } = result;
      this.setNotice(articles || []);
    }
  }

  @action.bound
  async getAppUrl(platform: string) {
    const result: any = await Axios.get(getExchangeUrl().appUrl, {
      params: {
        platform,
      },
    });
    if (result) {
      const { url } = result;
      switch (platform.toLowerCase()) {
        case 'android':
          this.setAppUrl(url);
          break;
        case 'ios_testflight':
          this.setIphoneUrl(url);
          break;
        case 'ios_appstore':
          this.setIosUrl(result);
          break;
        case 'google':
          this.setGoogleUrl(url);
          break;
      }
    }
  }
  @action.bound
  async fetchConf() {
    const result: any = await Axios.get(getExchangeUrl().conf);
    if (result) {
      this.setConfList(result);
    }
  }
}
